import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityItem } from "../../entity/EntityItem";
import { EntityVariationImple } from "../../entity/EntityVariationImple";
import { EntityCondition } from "../../entity/EntityCondition";

export class DtoItemsPutReq extends EntityItem {

  public variations: EntityVariationImple[] = [];

  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_item_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
